<template>
	<div>

	</div>
</template>
<script>
 const listdata = [
    {
      title:"泛物网络售电支持平台",
      url:"../../static/img/chanpin1.jpg",
      text:"泛物网络售电支持平台是国内领先的售电定制平台——是结合能源互联网、大数据、云计算技术以及多年的能源运营管理经验的创新应用。通过整合业内优势资源，为企业从前端降低能源价格；通过泛物售电支 持平台的运营，降低能源运维成本；并不断优化能源使用场景。致力于为用户提供全方位的智慧能源解决方案和智能化能源综合服务，实现为企业节能降耗。",
      type:"1",
      id:'1',
      text2:"泛物网络售电支持平台提供满足售电业务开展过程中所需要的客户关系管理、合同管理、购售电交易、现货交易、用能信息管理、负荷预测、收益结算等功能服务支撑售电公司与电厂、电网、电力交易中心、电力用 户等主体之间的业务联系，可为相关业务系统提供数据交互接口，满足业务办理及客户服务的数据需求。",
      img:["../../static/img/cpimg1.png"]
    },
    {
      title:"泛物网络数据监控平台",
      url:"../../static/img/jkpt.jpg",
      text:"泛物网络数据监控平台主要应用于电力行业的数字化建设，响应国家泛在电力物联网的部署要求，建立电量的管理。降低运维成本。产生更好的社会效益及经济效益。提供优秀的电力数据管理能力和与之的节能方案。打造集资产管理、运维管控、状态监测等功能为一体化的生态体系。",
      text2:"购售电经营：提供全方位售电业务信息化支撑，满足客户服务、售电测算、增值服务、场营销等售电公司基本业务，售电公司可借助配售电平台快速开展售电及相关业务。\n综合能效服务：“量体裁衣”制定优质节能方案，提高用电效率、优化资源配置、采取有效措施，积极推进“节能减排”，帮助客户不断提高经济效益。\n精准运维：依托大数据分析开展精准运维，实现有周期、有重点的全方位巡视，确保设备运维高质高效，在为用户提供周到的运维服务的同时，充分挖掘与提升产品的售后价值。",
      img:["../../static/img/dpksh.jpg"],
      type:'1',
      id:'2'
    },
    {
      title:"泛物网络物联网中心平台",
      url:"../../static/img/zxpt.jpg",
      text:"泛物网络物联网中心平台将大数据存储、分析、应用及云计算方面的技术与物联网通讯、设备远程智能维护服务有效结合。应用于能源行业、工业企业、工业园区等相关领域，对能源仪表及设备实时监控和控制，实现对生产过程的精细化管理，进一步规范企业能源管理，将低耗能，提高生产效率。",
      text2:"泛物网络物联网中心平台 包含购电管理、 售电管理、数据采集、客户关系管理、统计查询等配售电关键 环节的业务信息系统高度耦合，实现业务应用的灵活开发与落地， 构建电力能源互联新生态。提供专业的综合电力服务解决方案，帮助能源企业应对市场变革与竞争挑战，快速搭建标准化或定制化商业平台。",
      img:["../../static/img/1606726599(1).png"],
      type:'1',
      id:'3'
    },
    {
      title:"泛物网络城市供水管网检测平台",
      url:"../../static/img/cpimg7.png",
      text:"中国水资源短缺，人均水资源占有量约为2100立方米，为世界平均水平的四分之一。按国际标准，人均水资源低于3000立方米为轻度缺水，低于2000立方米为中度缺水，低于1000立方米为重度缺水，低于500立方米为极度缺水。照此，目前中国有16个省(区、市)重度缺水，有6个省、区极度缺水。我国的城市供水管网漏损率执行的标准主要是行业标准《城市供水管网漏损控制及评定标准》，该标准提出漏损率实际最高可达18%。“在10多年的执行中，全国只有少数城市能够达标。中国城市供水管网漏损达20%以上，除去正常范围内的流失率，如果能够降低10个百分点，即可节省至少200亿立方米水，保守计算相当于30多个密云水库的水量。市场规模千亿。",
      text2:"我公司研发的供水管网智能检测潜航器及配套的城市供水管网监测诊断系统。\n通过独特有的分布式信号传输方式完美解决了检测设备与监测系统的衔接。可以简单有效的绘制管网漏失损坏三维模型。",
      img:["../../static/img/20200731103459.png"],
      type:'2',
      id:'4'
    }
  ]
  export default {
    listdata
  }
</script>



// WEBPACK FOOTER //
// src/components/common/template.vue